import * as echarts from 'echarts/core'
import { LineChart, PieChart } from 'echarts/charts'
import {
  AriaComponent,
  GridComponent,
  TitleComponent,
  TooltipComponent
} from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'

echarts.use([
  LineChart,
  PieChart,
  AriaComponent,
  GridComponent,
  TitleComponent,
  TooltipComponent,
  CanvasRenderer
])

export default echarts
